// ----------------------------------------------------------------------------
// Разные мелкие функции для ЛК
// ----------------------------------------------------------------------------



import ttLKLogout from "./tt-LK-logout.js";
import {authElements} from "../auth-common/auth-account-elements.js";


// ----------------------------------------------------------------------------
// Имя на фокус и скрываем лишнее

export function ttLKFocusName() {
    authElements.ttAuthName?.focus();
    const button = document.getElementById('js-myaccount-form-resume__btn');
    if (button) button.style.display = '';

    document.querySelectorAll('.js-myaccount-form-resume__confirm')
        .forEach(confirmElement => confirmElement.style.display = 'none');
}



// ----------------------------------------------------------------------------
// Для работы мобильного меню

export const ttMobMenuChange = (v) => {
    const value = String(v);

    if (value === '-1') {
        ttLKLogout();
        return;
    }

    if (value.startsWith('//')) {
        window.location.href = value;
    } else {
        window.location.href = `//${window.location.host}${value}`;
    }
};
